import React, { useContext } from "react"

import { Store } from "~components/Markdown"
import MicrocopyContext from "~contexts/MicrocopyContext"

/**
 * Renders the list of credentials once the app has been created
 */
const Credentials = ({ id }) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      <Store disabled inline id={`${id}_credentials.client_id`}>
        {microcopy.text("app_button.credentials.client_id")}
      </Store>
      <Store disabled inline obscured id={`${id}_credentials.client_secret`}>
        {microcopy.text("app_button.credentials.client_secret")}
      </Store>
    </>
  )
}

export default Credentials
